import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import TitleBar from "../../../../partials/content/TitleBar";

export default function ViewBanner() {
  const params = useParams();
  const initAdvertise = {
    link: "",
    files: {},
  };
  const [advertise, setAdvertise] = useState(initAdvertise);
  const advertiseID = params.advertiseID;

  useEffect(() => {
    getAdvertise();
  }, []);

  const getAdvertise = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAdvertise = await sendRequestGetAdvertise(
      advertiseID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAdvertise) {
      return;
    }

    setAdvertise(resultSendRequestGetAdvertise);
  };

  const sendRequestGetAdvertise = async (advertiseID) => {
    const headersRequest = getHeaderRequest();
    let advertiseBanner;
    try {
      advertiseBanner = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/banner/" +
          advertiseID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return advertiseBanner.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateBannerImage = () => {
    if (Object.keys(advertise.files).length == 0) {
      return;
    }

    return Object.entries(advertise.files).map((banner, index) => {
      const bannerSize = banner[0];
      const bannerSizeSplit = bannerSize.split("-");
      const bannerWidth = bannerSizeSplit[0];
      const bannerHeight = bannerSizeSplit[1];

      const bannerImageUrl = banner[1].file_name;
      return (
        <div key={index} className="mb-2  ">
          <div
            className="text-center font-weight-bold bg-success text-dark"
            dir="ltr"
          >
            <span>{helperNumber.toPersianNum(bannerWidth)}</span>
            <span className="px-2">
              <i className="fa fa-times"></i>
            </span>
            <span>{helperNumber.toPersianNum(bannerHeight)}</span>
          </div>
          <div>
            <a href={generateBannerImageUrl(bannerImageUrl)} target="_blank">
              <img
                className="img-fluid"
                src={generateBannerImageUrl(bannerImageUrl)}
              />
            </a>
          </div>
        </div>
      );
    });
  };

  const generateBannerImageUrl = (bannerImageUrl) => {
    return (
      process.env.REACT_APP_DOMAIN_API +
      "/" +
      process.env.REACT_APP_URL_ADVERTISE_FILES +
      "/banner/" +
      bannerImageUrl
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تبلیغ بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-advertise-banner">
              <div className="alert alert-info">
                <p className="text-white m-0">
                  <span>
                    <i className="fa fa-info pl-2"></i>
                  </span>
                  <span>۱۵ ثانیه حداکثر زمان برای بنر های gif هست.</span>
                  <p className="m-0 py-2"> حداکثر حجم فایل ۱۵۰ کیلوبایت است.</p>
                </p>
              </div>
            </div>
            <div className="form-group px-4">
              <label>آدرس صفحه‌ی فرود تبلیغ شما </label>
              <div class="input-group">
                <input
                  type="text"
                  disabled={true}
                  defaultValue={advertise.link}
                  class="form-control"
                />
                <div class="input-group-append">
                  <a
                    href={advertise.link}
                    target="_blank"
                    class="btn btn-primary"
                    type="submit"
                  >
                    <i className="fa fa-link"></i>
                  </a>
                </div>
              </div>
            </div>

            <div
              className="d-flex flex-column align-items-center"
              id="img-upload-banners-container"
            >
              {generateBannerImage()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
